import React, { useEffect } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  styled,
  tableCellClasses,
  Menu,
  MenuItem,
  TextField,
  Grid,
  CircularProgress,
  Autocomplete,
  Chip,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Breadcrumbs,
  Container,
} from "@mui/material";
import {
  useGetProductSectionByIdMutation,
  useAddProductSectionItemMutation,
  useGetProductSectionItemsQuery,
  useDeleteProductSectionItemMutation,
  useUpdateProductSectionItemMutation,
} from "../../redux/reducer/features/Product/productSlice";
import PageLoader from "../app/PageLoader";
import { Link, useParams } from "react-router-dom";
import ScrollContainer from "react-indiana-drag-scroll";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import { AppFilter } from "../../models/app/AppModels";
import { useGetPartsMutation } from "../../redux/reducer/features/Part/partSlice";
import { Carousel } from "react-responsive-carousel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const numericRegex = /^[0-9]*$/;

const ViewSection: React.FunctionComponent = () => {
  let { id } = useParams();
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const [productSection, setProductSection] = React.useState<any>();
  const [productSectionItems, setProductSectionItems] = React.useState<any>();
  const [productSectionMutation, productSectionMutationResult] =
    useGetProductSectionByIdMutation();
  const [partsDataMutation, partsDataMutationResult] = useGetPartsMutation();
  const [addSectionItemMutation, addSectionItemMutationResult] =
    useAddProductSectionItemMutation();
  const [updateSectionItemMutation, updateSectionItemMutationResult] =
    useUpdateProductSectionItemMutation();
  const { data: sectionItemsResult, isSuccess } =
    useGetProductSectionItemsQuery({ productSectionId: id });
  const [
    deleteProductSectionItemsMutation,
    deleteProductSectionItemsMutationResult,
  ] = useDeleteProductSectionItemMutation();
  const [isOpen, setOpen] = React.useState(false);
  const [URL, setURL] = React.useState("");
  const [serialNumber, setSerialNumber] = React.useState("");
  const [addPartOpen, setAddPartOpen] = React.useState(false);
  const [viewPartOpen, setViewPartOpen] = React.useState(false);
  const [searchPart, setSearchPart] = React.useState("");
  const [partOption, setPartOption] = React.useState<any[]>([]);
  const [selectedPart, setSelectedPart] = React.useState<any>(null);
  const [selectedIcon, setSelectedIcon] = React.useState<any>();
  const [latestIcon, setLatestIcon] = React.useState<any>(null);
  const [iconAnchorEl, setIconAnchorEl] = React.useState<null | HTMLElement>(
    null
  );
  const [item, setItem] = React.useState<
    { id?: string; left: number; top: number }[]
  >([]);

  React.useEffect(() => {
    productSectionMutation({ data: { id: id } });
  }, []);
  React.useEffect(() => {
    GetParts();
  }, [paging]);

  React.useEffect(() => {
    if (addPartOpen) {
      setPaging({ ...paging, quickFilterValues: [searchPart] });
    }
  }, [searchPart]);

  const GetParts = () => {
    partsDataMutation({ paging: paging });
  };
  React.useEffect(() => {
    if (partsDataMutationResult.isSuccess && partsDataMutationResult.data) {
      console.log(partsDataMutationResult.data);
      setPartOption(partsDataMutationResult.data.entityList);
    }
  }, [partsDataMutationResult]);
  React.useEffect(() => {
    if (isSuccess && sectionItemsResult) {
      console.log("Items", sectionItemsResult?.entityList);
      var data = sectionItemsResult?.entityList
        .filter((i: any) => i.topPosition && i.topPosition !== "")
        .map((item: any) => ({
          id: item.id,
          top: item.topPosition,
          left: item.leftPosition,
        }));
      setItem(data);
      setProductSectionItems(sectionItemsResult?.entityList);
    }
  }, [sectionItemsResult]);

  const handleClose = () => {
    setViewPartOpen(false);
  };
  const handleLightBoxClose = () => {
    setOpen(false);
  };
  const handleAddPartClose = () => {
    setAddPartOpen(false);
    setSerialNumber("");
    setSelectedPart(null);
    setSearchPart("");
  };
  const handleChange = (event: any) => {
    const newValue = event.target.value;
    if (numericRegex.test(newValue)) {
      setSerialNumber(newValue);
    }
  };
  const handleIconClose = () => {
    setIconAnchorEl(null);
  };

  const handleAddSectionItem = () => {
    var data = {
      itemNumber: serialNumber,
      topPosition: selectedIcon?.top,
      leftPosition: selectedIcon?.left,
      productSectionId: id,
      partId: selectedPart?.id,
    };
    addSectionItemMutation({ data: data });
  };
  useEffect(() => {
    if (
      addSectionItemMutationResult.isSuccess &&
      addSectionItemMutationResult.data.entity
    ) {
      setProductSectionItems([
        ...productSectionItems,
        { ...addSectionItemMutationResult.data?.entity, part: selectedPart },
      ]);
      setItem(
        item.map((value: any) =>
          value.left.toString() ===
            addSectionItemMutationResult.data?.entity.leftPosition &&
          value.top.toString() ===
            addSectionItemMutationResult.data?.entity.topPosition
            ? {
                left: value.left,
                top: value.top,
                id: addSectionItemMutationResult.data?.entity.id,
              }
            : value
        )
      );
      setLatestIcon(null);
      setSelectedPart(null);
      handleAddPartClose();
    }
  }, [addSectionItemMutationResult]);
  useEffect(() => {
    if (productSectionMutationResult.isSuccess) {
      setProductSection(productSectionMutationResult.data.entity);
    }
  }, [productSectionMutationResult]);

  const handleImageClick = (event: any) => {
    const bounds = event.target.getBoundingClientRect();
    const x = event.clientX - bounds.left - 20;
    const y = event.clientY - bounds.top - 20;
    setItem([...item, { left: x, top: y }]);
    setLatestIcon({ left: x, top: y });
  };

  const handleIconClick = (event: any, item: any) => {
    setIconAnchorEl(event.currentTarget);
    setSelectedIcon(item);
  };

  const handleUpdateItem = (item: any) => {
    var data = {
      id: item?.id,
      itemNumber: item?.itemNumber,
      topPosition: latestIcon?.top,
      leftPosition: latestIcon?.left,
      productSectionId: item?.productSectionId,
      partId: item?.partId,
    };
    updateSectionItemMutation({ data: data });
  };
  useEffect(() => {
    if (
      updateSectionItemMutationResult.isSuccess &&
      updateSectionItemMutationResult.data.entity
    ) {
      setProductSectionItems(
        productSectionItems.map((item: any) =>
          item.id === updateSectionItemMutationResult.data.entity?.id
            ? {
                ...item,
                leftPosition:
                  updateSectionItemMutationResult.data.entity?.leftPosition,
                topPosition:
                  updateSectionItemMutationResult.data.entity.topPosition,
                itemNumber:
                  updateSectionItemMutationResult.data.entity.itemNumber,
              }
            : item
        )
      );
      setItem(
        item.map((value: any) =>
          value.left.toString() ===
            updateSectionItemMutationResult.data?.entity.leftPosition &&
          value.top.toString() ===
            updateSectionItemMutationResult.data?.entity.topPosition
            ? {
                left: value.left,
                top: value.top,
                id: updateSectionItemMutationResult.data?.entity.id,
              }
            : value
        )
      );

      setSelectedPart(null);
      handleAddPartClose();
      setLatestIcon(null);
    }
  }, [updateSectionItemMutationResult]);

  const handleViewPart = () => {
    setSelectedPart(
      productSectionItems
        .filter((item: any) => item.id === selectedIcon?.id)
        .map((item: any) => item.part)
    );
    setViewPartOpen(true);
  };

  const handleViewPartByPartId = (partId: any) => {
    setSelectedPart(
      productSectionItems
        .filter((item: any) => item.partId === partId)
        .map((item: any) => item.part)
    );
    setViewPartOpen(true);
  };

  const handleEditTableCell = (e: any, item: any) => {
    if (item?.itemNumber.toString() === e.target.innerText) {
      return;
    }

    var data = {
      id: item?.id,
      itemNumber: e.target.innerText,
      topPosition: item?.topPosition,
      leftPosition: item?.leftPosition,
    };
    updateSectionItemMutation({ data: data });
  };
  const handleItemDelete = (icon: any) => {
    setItem(item.filter((n) => n.id !== icon?.id));
    setProductSectionItems(
      productSectionItems.filter((item: any) => item.id !== icon?.id)
    );
    deleteProductSectionItemsMutation({ data: { id: icon?.id } });
  };
  const handleIconDelete = (icon: any) => {
    if (icon?.id) {
      var data = {
        id: icon?.id,
        topPosition: "",
        leftPosition: "",
      };
      updateSectionItemMutation({ data: data });
      setItem(item.filter((n) => n.id !== selectedIcon?.id));
    } else {
      if (latestIcon?.top === icon.top && latestIcon?.left === icon.left) {
        setLatestIcon(null);
      }
      setItem(item.filter((n) => n.left !== icon.left && n.top !== icon.top));
    }
    setIconAnchorEl(null);
  };

  return (
    <Container maxWidth="lg">
      <PageLoader isLoading={productSectionMutationResult.isLoading} />
      <Card
        style={{
          padding: "10px",
          margin: "10px",
          marginRight: 0,
          marginLeft: "55px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" to="/">
            Dashboard
          </Link>
          <Link color="inherit" to="/Products">
            Products
          </Link>

          <Typography color="text.primary">View Section</Typography>
        </Breadcrumbs>
      </Card>
      <Grid container>
        <Grid item md={6}>
          {" "}
          <ScrollContainer
            style={{
              marginLeft: "55px",
              maxWidth: "80%",
              maxHeight: "80%",
              overflow: "auto",
              border: "1px solid black",
              position: "relative",
            }}
          >
            <img
              alt="draggable"
              src={
                "https://digitalinnovationcaba96.blob.core.windows.net/product-catalog/ProductImage/" +
                productSection?.imgUrl
              }
              style={{ cursor: "pointer" }}
              onClick={handleImageClick}
            ></img>
            {item.map((n) => (
              <>
                <PanoramaFishEyeIcon
                  style={{
                    position: "absolute",
                    left: n.left,
                    top: n.top,
                    width: "40px",
                    height: "40px",
                    color: n.id
                      ? "#63993ade"
                      : n?.left === latestIcon?.left &&
                        n?.top === latestIcon?.top
                      ? "red"
                      : "#ffcc00",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    handleIconClick(e, n);
                  }}
                />
                <Menu
                  id="simple-menu"
                  anchorEl={iconAnchorEl}
                  keepMounted
                  open={Boolean(iconAnchorEl)}
                  onClose={handleIconClose}
                >
                  {selectedIcon?.id ? (
                    <MenuItem onClick={handleViewPart}>View</MenuItem>
                  ) : (
                    <MenuItem
                      onClick={() => {
                        setSelectedPart(null);
                        setAddPartOpen(true);
                      }}
                    >
                      Add Part
                    </MenuItem>
                  )}

                  <MenuItem
                    onClick={() => {
                      handleIconDelete(selectedIcon);
                    }}
                  >
                    Remove
                  </MenuItem>
                </Menu>
              </>
            ))}
          </ScrollContainer>
        </Grid>
        <Grid item md={6}>
          <Card>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Sr.No</TableCell>
                  <TableCell sx={{ fontWeight: "bold", pl: 6 }} align="left">
                    Title
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productSectionItems && productSectionItems.length > 0
                  ? productSectionItems
                      .slice()
                      .sort((a: any, b: any) => a.itemNumber - b.itemNumber)
                      .map((item: any, index: number) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell
                            contentEditable={true}
                            onBlur={(event) => {
                              handleEditTableCell(event, item);
                            }}
                            component="th"
                            scope="row"
                          >
                            {item.itemNumber}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              {item.part?.images[0]?.url ? (
                                <div
                                  style={{
                                    width: "25px",
                                    height: "30px",
                                    backgroundColor: "white",
                                    borderRadius: "0.25rem",
                                    border: "1px solid #DEE2E6",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setOpen(true);
                                    setURL(
                                      item.part?.images[0]?.absoluteUrl ?? ""
                                    );
                                  }}
                                >
                                  <img
                                    style={{ width: "100%", height: "100%" }}
                                    alt=""
                                    src={item.part?.images[0]?.absoluteUrl}
                                  ></img>
                                </div>
                              ) : (
                                ""
                              )}
                              <Typography
                                sx={{
                                  ml: 2,
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                {item?.part?.title}
                              </Typography>
                            </Box>
                          </StyledTableCell>

                          <StyledTableCell align="center">
                            <IconButton
                              disabled={
                                item?.leftPosition === ""
                                  ? latestIcon === null
                                    ? true
                                    : false
                                  : true
                              }
                              id="basic-button"
                              onClick={(n) => {
                                handleUpdateItem(item);
                              }}
                            >
                              <AddCircleOutlineIcon fontSize="small" />
                            </IconButton>
                            |{" "}
                            <IconButton
                              id="basic-button"
                              onClick={(e) => {
                                handleViewPartByPartId(item?.partId);
                              }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                            |
                            <IconButton
                              disabled={
                                deleteProductSectionItemsMutationResult.isLoading
                              }
                              id="basic-button"
                              onClick={(n) => {
                                handleItemDelete(item);
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                  : ""}
              </TableBody>
            </Table>
          </Card>
        </Grid>
      </Grid>

      {isOpen && (
        <Lightbox mainSrc={URL} onCloseRequest={handleLightBoxClose} />
      )}
      <Dialog open={addPartOpen} onClose={handleAddPartClose}>
        <DialogTitle alignSelf={"center"}>Add Section Item</DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={3}
            justifyContent="space-between"
            display="flex"
            p={5}
          >
            <Grid item xs={12}>
              <TextField
                id="title"
                name="title"
                label="Serial Number"
                fullWidth
                autoComplete="family-name"
                variant="standard"
                onChange={handleChange}
                value={serialNumber}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                freeSolo
                id="tags-standard"
                disableClearable
                getOptionLabel={(option: any) =>
                  option.title +
                  " " +
                  option.shortName +
                  ", " +
                  option.partNumber
                }
                options={partOption}
                style={{ padding: "0px", margin: "1px !important" }}
                onBlur={(e) => {}}
                clearOnBlur
                onKeyDown={(event: any) => {
                  setSearchPart(event.target.value);
                }}
                onKeyUp={(event: any) => {
                  setSearchPart(event.target.value);
                }}
                onChange={(event, newValue) => {
                  setSelectedPart(newValue);
                }}
                value={selectedPart}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      color="primary"
                      size="medium"
                      label={option}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    id="part"
                    name="part"
                    label="Add Part"
                    type="text"
                    placeholder="Seacrg by name, email, phone..."
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} mt={3}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-end"
              >
                <Grid item>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => {
                      handleAddPartClose();
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    disabled={
                      addSectionItemMutationResult.isLoading ||
                      serialNumber.length === 0 ||
                      selectedPart === null
                    }
                    variant="contained"
                    type="submit"
                    startIcon={
                      addSectionItemMutationResult.isLoading ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        ""
                      )
                    }
                    onClick={() => {
                      handleAddSectionItem();
                    }}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        className="check"
        maxWidth={"lg"}
        open={viewPartOpen}
        fullWidth
        onClose={handleClose}
      >
        <DialogTitle alignSelf={"center"}>Part Detail</DialogTitle>
        <DialogContent>
          <Card style={{ padding: "10px", margin: "10px" }}>
            <Grid container spacing={4} justifyContent="flex-start">
              <Grid item xs={12} md={6} pr={2}>
                {selectedPart && selectedPart[0]?.images ? (
                  <Carousel width={"100%"}>
                    {selectedPart[0]?.images.map((img: any) => {
                      return (
                        <div
                          onClick={() => {
                            setURL(img?.absoluteUrl ?? "");
                            setOpen(true);
                          }}
                        >
                          <img
                            style={{ width: "100%" }}
                            src={img?.absoluteUrl ?? ""}
                          ></img>
                        </div>
                      );
                    })}
                  </Carousel>
                ) : (
                  ""
                )}
              </Grid>
              <Grid
                item
                mt={4}
                xs={12}
                md={6}
                sx={{
                  border: "1px solid #dee2e6 !important",
                  minHeight: "70vh",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 700, textTransform: "uppercase" }}
                >
                  {selectedPart ? selectedPart[0]?.title : ""}
                </Typography>
                <Divider />
                <Typography
                  mt={3}
                  mb={3}
                  sx={{ fontWeight: 700, fontSize: "1.5rem" }}
                >
                  Part Overview
                </Typography>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography sx={{ fontWeight: 700 }}>
                      Description
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      <span
                        dangerouslySetInnerHTML={{
                          __html:
                            selectedPart && selectedPart[0]?.description
                              ? selectedPart[0]?.description
                              : "",
                        }}
                      ></span>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography sx={{ fontWeight: 700 }}>
                      Weight & Dimension
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Height</TableCell>
                          <TableCell align="right">Weight</TableCell>
                          <TableCell align="right">Length</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {selectedPart
                              ? selectedPart[0]?.dimension?.height
                              : ""}
                            in
                          </TableCell>
                          <TableCell align="right">
                            {selectedPart
                              ? selectedPart[0]?.dimension?.weight
                              : ""}
                            lbs
                          </TableCell>
                          <TableCell align="right">
                            {selectedPart
                              ? selectedPart[0]?.dimension?.depth
                              : ""}
                            in
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                  >
                    <Typography sx={{ fontWeight: 700 }}>
                      Specifications
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Table aria-label="customized table">
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell component="th">
                            Part Number
                          </StyledTableCell>
                          <StyledTableCell>
                            {selectedPart ? selectedPart[0]?.partNumber : ""}
                          </StyledTableCell>
                        </StyledTableRow>

                        <StyledTableRow>
                          <StyledTableCell>Tags</StyledTableCell>
                          <StyledTableCell>
                            {selectedPart && selectedPart[0]?.tags
                              ? selectedPart[0]?.tags.map((item: any) => (
                                  <Chip label={item} />
                                ))
                              : ""}
                          </StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>{" "}
          </Card>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              setViewPartOpen(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ViewSection;
